import { Link } from "react-router-dom";
import { Hero } from "@/components/Hero";
import { Guarantees } from "@/components/Guarantees";
import { SportsOverview } from "@/components/SportsOverview";
import { SessionScience } from "@/components/SessionScience";
import { Reveal } from "@/components/Reveal";

export default function Home() {
  return (
    <>
      <Hero />
      <Guarantees />
      <Reveal><SportsOverview /></Reveal>
      <Reveal><SessionScience /></Reveal>
      <section className="mx-auto max-w-5xl px-5 py-16 lg:px-8">
        <div className="rounded-[2rem] bg-gradient-to-br from-[#0E9E96] to-[#0B6F6A] p-8 text-center text-white sm:p-12">
          <h2 className="font-head text-3xl font-extrabold sm:text-4xl">Ready for a tailored quote?</h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-teal-50/85">
            Tell us about your group and we'll send custom program pricing within 4 hours. Zero lock-in, always.
          </p>
          <Link
            to="/inquire"
            data-testid="home-cta-inquire"
            className="mt-6 inline-flex rounded-full bg-[#FACC15] px-8 py-3.5 font-head text-base font-extrabold text-[#5A4300] shadow-lg transition-transform hover:scale-105"
          >
            Request Custom Quote / Subsidised Trial Rate
          </Link>
        </div>
      </section>
    </>
  );
}
